import cx from 'classnames'
import React from 'react'

import LoadingSpinner from '@cinch/oxd-components/loading-spinner/src'
import SVG from '@cinch/oxd-components/svg/src'
// import directly from module due to an unknown breaking issue with lerna/yarn workspaces
import { buildTagDataAttr } from '@cinch/oxd-utils/analytics/src/build-tag-data-attr'

import * as baseStyles from './base-button.module.css'

interface ButtonStyles {
  base?: string
  disabled?: string
  fullWidth?: string
  loading?: string
  content?: string
  button?: string
}

export type BaseButtonSize = 'mini' | 'regular' | 'large'

export interface BaseButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  isFullWidth?: boolean
  isLoading?: boolean
  styles?: ButtonStyles
  className?: string
  size?: BaseButtonSize
  icon?: any
  iconProps?: any
  tag?: Cinch.AnalyticsTag
}

function getButtonSizeStyle(size: BaseButtonSize) {
  switch (size) {
    case 'large':
      return baseStyles.large
    case 'mini':
      return baseStyles.mini
    case 'regular':
    default:
      return baseStyles.regular
  }
}

const BaseButton: React.FC<BaseButtonProps> = ({
  children,
  isFullWidth,
  styles = {},
  disabled,
  isLoading,
  size,
  className,
  icon,
  iconProps = {},
  tag,
  ...rest
}) => {
  const mergedStyles: any = { ...baseStyles, ...styles }
  const buttonClass = cx(
    mergedStyles.base,
    mergedStyles.button,
    getButtonSizeStyle(size!),
    {
      [mergedStyles.disabled]: disabled,
      [mergedStyles.fullWidth]: isFullWidth,
      [mergedStyles.loading]: isLoading,
    },
    className,
  )

  const analyticsDataAttributes = buildTagDataAttr(tag)

  const restProps: any = {
    ...rest,
    ...analyticsDataAttributes,
    ...(disabled || isLoading ? { disabled: 'disabled' } : {}),
  }

  return (
    <button className={buttonClass} {...restProps}>
      <div className={cx(mergedStyles.content, { [baseStyles.contentLoading]: isLoading })}>
        {icon && (
          <div className={cx(baseStyles.icon, { [baseStyles.iconLoading]: isLoading })}>
            <SVG {...iconProps} children={icon} size="14px" hasGradient={true} />
          </div>
        )}
        {children}
      </div>
      {isLoading && <LoadingSpinner className={baseStyles.spinner} backgroundCircleColor={'none'} size={28} />}
    </button>
  )
}

export default BaseButton
